import { render } from "./Debark.vue?vue&type=template&id=4825a558&scoped=true"
import script from "./Debark.vue?vue&type=script&lang=js"
export * from "./Debark.vue?vue&type=script&lang=js"

import "./Debark.vue?vue&type=style&index=0&id=4825a558&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4825a558"]])

export default __exports__